<a [href]="skipToMainContentLink" class="sr-only skip-link">Skip to Main Content</a>
<cir-pub-header></cir-pub-header>
<div class="container main-body">
  <div class="row">
    <div class="col-md-2 left-nav-container top-pad">
      <cir-pub-left-nav></cir-pub-left-nav>
    </div>
    <div class="col-md-10 cir-main-content top-pad" id="router-outlet-container" [@routerTransition]="getPage(appOutlet)">
      <!-- The router-outlet is a part of Angular Routing. -->
      <router-outlet #appOutlet="outlet"></router-outlet>
    </div>
  </div>
</div>
<cir-pub-footer class="container"></cir-pub-footer>
